<div *ngIf="title && !isPostSubmission" class="sr-only" role="status" aria-live="polite">{{ title }}</div>

<finra-mu3-header
  *ngIf="!isPostSubmission && !hasRoutingError"
  class="mu3-header"
  [class.standalone]="isStandalone"
  aria-label="header"
  role="banner"
  [branchName]="branchName"
  [branchId]="subjectId"
  [branchLoaded]="branchLoaded"
  [isFormView]="formView"
></finra-mu3-header>

<div *ngIf="!isPostSubmission">
  <finra-page-level-nav
    [data]="navData$ | async"
    [isCollapsible]="false"
    id="app-mu3-form-navigator"
    [width]="(loading$ | async) ? '0px' : navWidth"
    (navSelected)="navigateToMenu($any($event).detail)"
    aria-label="navigation"
    role="navigation"
  >
    <div class="form-content">
      <ng-container *ngIf="loading$ | async; else form">
        <div class="center-page">
          <finra-spinner [isBackdrop]="false"></finra-spinner>
        </div>
      </ng-container>

      <ng-template #form>
        <router-outlet></router-outlet>
      </ng-template>
    </div>
  </finra-page-level-nav>

  <app-footer
    *ngIf="!(loading$ | async) && !hasRoutingError && (!isRegulatorUser || viewType === 'formView')"
    [ngStyle]="{ display: isPrintMode ? 'none' : null }"
    [class.standalone]="isStandalone"
    (save)="onSave($event)"
    (submit)="onSubmit()"
    (updateOptions)="updateFooterOptions($event)"
    (validate)="onValidate()"
    (back)="onBack()"
    (next)="onNext()"
    (print)="onPrint()"
    (redline)="onToggleRedline($event)"
    [saveInProgress]="saveInProgress"
    [viewType]="viewType"
    [section]="currentNavId"
    [sectionNavData]="navrouteData"
    [lastOpenedSectionDE]="lastOpenedSectionDE"
    aria-label="footer"
    role="contentinfo"
  >
  </app-footer>

  <rampdi-completeness-check
    [data]="completenessCheck$ | async"
    (onclick)="navigateToField($event)"
    (close)="closeWidget()"
    (refresh)="onValidate()"
    role="complementary"
    aria-label="Completeness check panel"
  >
  </rampdi-completeness-check>

  <rampdi-redline-widget
    *ngIf="viewType === 'formView'"
    [data]="redlineDiff$ | async"
    (onclick)="navigateToField($event)"
    (close)="closeWidget('redline')"
  ></rampdi-redline-widget>
</div>

<ng-container *ngIf="isPostSubmission">
  <router-outlet></router-outlet>
</ng-container>
